module.exports = __webpack_public_path__ + "img/img-work_detail_10.07ec63f9.png";